// This file is automatically generated. Do not edit manually.

import { ObjectAttributeValueWithField } from "src/api/generated/erp/common/objectAttributes/model/objectAttributeValueWithField";
import { CustomerOrderOfferView } from "src/api/generated/erp/db/types/tables/customerOrderOfferView";
import { CustomerOfferSummary } from "src/api/generated/erp/sales/customerOrderOffer/service/customerOfferSummary";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace SingleCustomerOfferViewApi {
	export async function getSingleCustomerOfferViewData(args: {
		customerOrderOfferId: number;
	}): Promise<SingleCustomerOfferViewApi_Data> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/customerOrderOffer/singleCustomerOfferView/getSingleCustomerOfferViewData",
			method: "POST",
			data: {
				customerOrderOfferId: args.customerOrderOfferId,
			},
		});
		return response as SingleCustomerOfferViewApi_Data;
	}
}

export interface SingleCustomerOfferViewApi_Data {
	attributes: Array<ObjectAttributeValueWithField>;
	offer: CustomerOrderOfferView;
	summary: CustomerOfferSummary;
}
